export const english = {
  brandName: require('./logo.svg'),
  background: require('./background.png'),
  logo: require('./logo.svg'),
  brandLogo: require("./brandLogo.png"),
  trigger: require('./trigger.svg'),
  poweredby: require("./poweredby.svg"),
  lottiejson: require('./lottie.json'),
  lowRating: require('./lowRating.png'),
  midRating: require('./midRating.png'),
  highRating: require('./highRating.png'),
  outerBackground: require('./outerBackground.jpg'),
  user: require("./user.png"),
  videoTrigger: require("./videoTrigger.webm"),
  feedbackIcons: [
    require("./angry.png"),
    require("./confounded.png"),
    require("./neutralFace.png"),
    require("./slightlySmilingFace.png"),
    require("./heartEyes.png"),
  ],
}

export const arabic = {
  brandName: require('./logo.svg'),
  background: require('./background.png'),
  logo: require('./logo.svg'),
  brandLogo: require("./brandLogo.png"),
  trigger: require('./trigger.svg'),
  poweredby: require("./poweredby.svg"),
  lottiejson: require('./lottie.json'),
  lowRating: require('./lowRating.png'),
  midRating: require('./midRating.png'),
  highRating: require('./highRating.png'),
  outerBackground: require('./outerBackground.jpg'),
  user: require("./user.png"),
  videoTrigger: require("./videoTrigger.webm"),
  feedbackIcons: [
    require("./angry.png"),
    require("./confounded.png"),
    require("./neutralFace.png"),
    require("./slightlySmilingFace.png"),
    require("./heartEyes.png"),
  ],
}

export const notification_sound = require("./notification.mp3")
